export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Pullopantti',
    },
    product_type: {
      label: 'Tuotetyyppi',
      options: {
        packaged: 'Pakattu',
        prepared: 'Valmistettu',
      },
    },
    packaging_material: {
      label: 'Pakkausmateriaali',
    },
    brand_or_manufacturer: {
      label: 'Brändi tai valmistaja',
    },
    net_quantity: {
      label: 'Nettomäärä',
    },
    base_price: {
      label: 'Aseta yksikköhinta (esim. litraa kohden juomalle)',
      placeholder: 'Yksikköhinta',
    },
    alcohol_by_volume_percent: {
      label: 'Alkoholipitoisuus',
    },
    caffeine_mg_per_100ml: {
      label: 'Kofeiini (mg / 100 ml tuotetta)',
    },
    ingredients_text: {
      label: 'Ainesosat',
    },
    allergens_list: {
      label: 'Allergeenit',
    },
    additives_list: {
      label: 'Lisäaineet',
    },
    has_nutrition_table: {
      label: 'Täytä ravintotaulukko (per 100{{unit}} tuotetta)',
    },
    energy_kj: {
      label: 'Energia (kJ)',
    },
    energy_kcal: {
      label: 'Energia (kcal)',
    },
    fat_g: {
      label: 'Rasva',
    },
    saturates_g: {
      label: 'Tyydyttyneet rasvat',
    },
    carbohydrate_g: {
      label: 'Hiilihydraatti',
    },
    sugars_g: {
      label: 'Sokeri',
    },
    protein_g: {
      label: 'Proteiini',
    },
    salt_g: {
      label: 'Suola',
    },
    identifiers: {
      label: 'Tunnisteet',
    },
  },
};
